import { render, staticRenderFns } from "./Avuka.vue?vue&type=template&id=0aad75f0&scoped=true&"
import script from "./Avuka.vue?vue&type=script&lang=js&"
export * from "./Avuka.vue?vue&type=script&lang=js&"
import style0 from "./Avuka.vue?vue&type=style&index=0&id=0aad75f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aad75f0",
  null
  
)

export default component.exports